import axios from "axios";
export const getNotifications = (data) => {
  return axios.get(`${process.env.REACT_APP_NOTIFICATION_SERVICE_API_URL_V2}/notifications/get-notifications?${new URLSearchParams(data).toString()}`);
}
export const notificationStatusUpdate = (data) => {
  return axios.put(`${process.env.REACT_APP_NOTIFICATION_SERVICE_API_URL_V2}/notifications/update-notifications`, data);

}